export default "__VITE_ASSET__DADTr9kn__"